import { PatientManagement } from '..';
import { useUserPatientManagementData } from './useUserPatientManagementData';

export const UserPatientManagement = () => {
  const {
    patients,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    pagination,
    setPagination,
    nextPage,
    total,
  } = useUserPatientManagementData();

  return (
    <PatientManagement
      patients={patients}
      total={total}
      nextPage={nextPage}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
      pagination={pagination}
      setPagination={setPagination}
    />
  );
};
